(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["active-facets"] && !Shopify.designMode) return;
  try {
    (function() {
  const body = document.body;

  function updateFilterClass() {
    const activeFacets = document.querySelectorAll('.active-facets .removable-facet');
    if (activeFacets.length > 0) {
      body.classList.remove('filter-active');
    } else {
      body.classList.add('filter-active');
    }
  }

  function observeFacets() {
    const container = document.querySelector('.active-facets');
    if (!container) return;

    const observer = new MutationObserver(updateFilterClass);
    observer.observe(container, { childList: true, subtree: true });

    updateFilterClass();
  }

  function observeBody() {
    const bodyObserver = new MutationObserver(() => {
      const container = document.querySelector('.active-facets');
      if (container) {
        observeFacets();
      }
      updateFilterClass();
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    observeFacets();
    observeBody();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
  } catch(e) { console.error(e); }
})();

})();
